import { Waves } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import SurfLevelSelector from './SurfLevelSelector';
import type { SurfLevel } from '@/lib/surf-progression';

interface SetSurfLevelCardProps {
  onSelect: (level: SurfLevel) => void;
}

/**
 * Onboarding empty state for the Surfing Journey -- shown to an
 * authenticated user who doesn't have a level yet (existing accounts from
 * before the sign-up flow collected one; anyone who lands here otherwise
 * already set a level at sign-up and never sees this). Self-selected, never
 * inferred -- see useSurfProgression.ts / user_profiles.surf_level.
 */
const SetSurfLevelCard = ({ onSelect }: SetSurfLevelCardProps) => (
  <Card className="border-border/50">
    <CardHeader className="text-center pb-2">
      <div className="mx-auto w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-3">
        <Waves className="h-7 w-7 text-primary" />
      </div>
      <CardTitle className="font-serif text-xl sm:text-2xl">Where are you in your surfing?</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-sm text-muted-foreground text-center max-w-sm mx-auto mb-6">
        Pick where you'd place yourself today. You'll be able to tell us more about what you can
        already do next.
      </p>
      <SurfLevelSelector value={null} onSelect={onSelect} className="max-w-md mx-auto" />
    </CardContent>
  </Card>
);

export default SetSurfLevelCard;
